/* eslint-disable import/prefer-default-export */
export enum MailProfileType {
  SAVE_PROFILE = 'userProfile/SAVE_PROFILE',
  CLEAN_PROFILE = 'userProfile/CLEAN_PROFILE',
  UPDATE_PROFILE = 'userProfile/UPDATE_PROFILE'
}
